import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "position-relative d-flex flex-column" }
const _hoisted_2 = ["name"]
const _hoisted_3 = {
  key: 0,
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_4 = ["value", "selected", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: "form-select__description"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "form-select__icon icon icon-arrow-down",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_FormErrors = _resolveComponent("FormErrors")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('form-group ' + _ctx.className)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FormLabel, {
        label: _ctx.label,
        id: _ctx.id,
        required: _ctx.required,
        class: _normalizeClass(_ctx.labelClassName)
      }, null, 8, ["label", "id", "required", "class"]),
      _createElementVNode("div", {
        class: _normalizeClass(["form-select__wrapper", [_ctx.description ? 'has-description' : '', _ctx.wrapperClassName]])
      }, [
        _createElementVNode("select", {
          class: _normalizeClass(["form-select", [_ctx.errors.length ? 'is-invalid' : '', _ctx.selectClassName]]),
          name: _ctx.name,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeValue($event.target.value))),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, [
          (_ctx.placeholder)
            ? (_openBlock(), _createElementBlock("option", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: option.value,
              key: index,
              selected: option.value === _ctx.selectedOption,
              disabled: !!option.disabled
            }, _toDisplayString(option.label), 9, _hoisted_4))
          }), 128))
        ], 42, _hoisted_2),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true),
        _hoisted_6
      ], 2)
    ]),
    _createVNode(_component_FormErrors, { errors: _ctx.errors }, null, 8, ["errors"])
  ], 2))
}